import React, { createContext, useEffect, useContext, useState } from 'react';

// Định nghĩa kiểu dữ liệu cho một chat (bạn có thể bổ sung thêm trường nếu cần)
export type Chat = {
    lastReadTime: number;
    messages: any[];
    contactName: string;
    contactNumber?: string;
    unitid?: string;
    read: boolean;
    lastInBoundMessageIndex: number;
    lastRealMessageIndex: number;
};
export type WarningZoneMessage={
    zoneId: string;
    message: string;
    unitIds: string[];
    sentTime: number;
}
type ChatContextType = {
    chats: Record<string, Chat>;
    setChats: React.Dispatch<React.SetStateAction<Record<string, Chat>>>;
    lastMessageDataTime: number;
    setLastMessageDataTime: React.Dispatch<React.SetStateAction<number>>;
    newMessageNotification: boolean;
    setNewMessageNotification: React.Dispatch<React.SetStateAction<boolean>>;
    warningZoneMessage: Record<string, WarningZoneMessage[]>;
    setWarningZoneMessage: React.Dispatch<React.SetStateAction<Record<string, WarningZoneMessage[]>>>;
};

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [chats, setChats] = useState<Record<string, Chat>>({});
    const [lastMessageDataTime, setLastMessageDataTime] = useState<number>(1);
    const [newMessageNotification, setNewMessageNotification] = useState<boolean>(false);
    const [warningZoneMessage, setWarningZoneMessage] = useState<Record<string, WarningZoneMessage[]>>({});
    useEffect(() => {
        if(chats && Object.keys(chats).some(key => !chats[key].read)) {
            setNewMessageNotification(true);
        } else {
            setNewMessageNotification(false);
        }
    }, [chats]);
    return (
        <ChatContext.Provider value={{ chats, setChats, warningZoneMessage, setWarningZoneMessage, lastMessageDataTime, setLastMessageDataTime, newMessageNotification, setNewMessageNotification }}>
            {children}
        </ChatContext.Provider>
    );
};

// Custom hook để sử dụng ChatContext dễ dàng
export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (!context) throw new Error('useChatContext must be used within ChatProvider');
    return context;
};